"use client";
import { styled } from "@mui/material/styles";
import { SpaceXxs, FontLineHeightMd, FontWeightBold, ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
const IconButtonWrapper = styled(CostcoBox)({
  display: "flex",
  gap: SpaceXxs
});
const LocationSelectorContainerSx = {
  width: {
    sm: 170,
    xs: 125
  }
};
const IconWrapper = styled(CostcoBox)({
  alignItems: "flex-start",
  display: "flex",
  paddingTop: "2px"
});
const buttonBaseStyles = {
  color: ColorTextDefault,
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  minWidth: "auto",
  textAlign: "left"
};
const LocationSelectorButtonSx = {
  ...buttonBaseStyles,
  fontWeight: FontWeightBold,
  lineHeight: FontLineHeightMd,
  whiteSpace: "nowrap"
};
const LocationSelectorButtonCMWSx = {
  ...buttonBaseStyles,
  textDecoration: "underline",
  lineHeight: FontLineHeightMd
};
export {
  IconButtonWrapper,
  IconWrapper,
  LocationSelectorButtonCMWSx,
  LocationSelectorButtonSx,
  LocationSelectorContainerSx
};
